import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface TrackingRequest {
    category: string;
}

export interface TrackingResponse {
    담당자번호: string;
    요청사항: string;
    받을주소: string;
    내용: string;
    상태: string;
    신청날짜: string;
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePostTrackingHistory = (
    successCallback?: (data: TrackingResponse[]) => void,
): UseMutationResult<TrackingResponse[], AxiosError<ApiErrorResponse>, TrackingRequest> => {
    const accessToken = useMorningAuthStore(state => state.accessToken);

    return useMutation<TrackingResponse[], AxiosError<ApiErrorResponse>, TrackingRequest>({
        mutationFn: async requestData => {
            const response = await axios.post(
                enum_api_uri.tracking_history,
                requestData,
                accessToken
                    ? {
                          headers: {
                              Authorization: `Bearer ${accessToken}`,
                              "Content-Type": "application/json",
                          },
                      }
                    : {},
            );
            return response.data.data;
        },
        onSuccess: data => {
            successCallback?.(data);
        },
    });
};
